//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { replaceSpecialCharacters } from '~/utils';

export default {
  name: 'JobCard',
  props: {
    item: { type: Object, default: () => {} },
  },
  data() {
    return {
      isFavorite: false,
    };
  },
  methods: {
    ...mapActions('jobs', ['setCurrentJobId', 'setCurrentCompanyId']),
    gotoCompany(id) {
      this.setCurrentCompanyId(id || 0);
      this.$router.push(`/Company/${id}`);
    },
    gotoJobsContent(item) {
      this.setCurrentJobId(item.id || 0);
      this.$router.push({
        path: `/JobsContent/${item.id}-${replaceSpecialCharacters(item.title)}`,
        query: { id: item.id },
      });
    },
  },
  mounted() {
    this.isFavorite = !!this.item.isFavorites;
  },
};
